var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"scale-card"},[_c('label',[_vm._v(_vm._s(_vm.labelText))]),_c('Scale',{attrs:{"scale":_vm.scale,"name":_vm.name},on:{"input":_vm.passThroughInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }